<script>
import { mapGetters } from 'vuex';
import LabelSelector from 'dashboard/components/widgets/LabelSelector.vue';
import Modal from 'dashboard/components/Modal.vue';

export default {
  components: {
    LabelSelector,
    Modal,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    isImporting: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedLabels: [],
    };
  },
  computed: {
    ...mapGetters({
      allLabels: 'labels/getLabels',
    }),
    selectedLabelTitles() {
      return this.selectedLabels.map(label => label.title);
    },
  },
  watch: {
    show(isVisible) {
      if (isVisible) {
        this.selectedLabels = [];
        this.$store.dispatch('labels/get');
      }
    },
  },
  methods: {
    onAddLabel(label) {
      if (!label?.title) return;
      if (this.selectedLabels.some(item => item.title === label.title)) return;

      this.selectedLabels.push(label);
    },
    onRemoveLabel(labelTitleToRemove) {
      this.selectedLabels = this.selectedLabels.filter(
        label => label.title !== labelTitleToRemove
      );
    },
    onClose() {
      this.$emit('close');
    },
    onConfirm() {
      this.$emit('confirm', this.selectedLabelTitles);
    },
  },
};
</script>

<template>
  <Modal :show="show" :on-close="onClose">
    <div class="flex flex-col h-auto overflow-visible">
      <woot-modal-header :header-title="title">
        <p v-if="description">{{ description }}</p>
      </woot-modal-header>
      <div class="flex flex-col p-8">
        <span class="text-sm">
          {{ $t('UAZAPI_IMPORT.LABELS_DESCRIPTION') }}
        </span>
        <LabelSelector
          :all-labels="allLabels"
          :saved-labels="selectedLabels"
          class="py-4"
          @add="onAddLabel"
          @remove="onRemoveLabel"
        />
        <p class="text-xs text-slate-600 dark:text-slate-400 mb-0">
          {{ $t('UAZAPI_IMPORT.LABELS_HINT') }}
        </p>
        <div class="flex flex-row justify-end w-full gap-2 px-0 py-2 mt-4">
          <woot-button variant="clear" @click.prevent="onClose">
            {{ $t('UAZAPI_IMPORT.CANCEL') }}
          </woot-button>
          <woot-button :is-loading="isImporting" @click="onConfirm">
            {{ $t('UAZAPI_IMPORT.SUBMIT') }}
          </woot-button>
        </div>
      </div>
    </div>
  </Modal>
</template>
